import Grid2 from "@mui/material/Unstable_Grid2";
import React from "react";

export interface EqualGridItemProps {
    children: React.ReactNode
}

export function EqualGridItem({children}: EqualGridItemProps) {
    return <Grid2 xs={12} md={6}> {children} </Grid2>
}